import React from 'react';
import {
  Box,
  Typography,
  Link,
  Paper,
  Divider,
  ListItem,
  List,
  ListItemText,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';

const CancellationRefund = () => {
  return (
    <Box>
      <Typography variant="homePageBody" paragraph>
        At{' '}
        <span style={{ fontFamily: 'SpaceGrotesk', fontWeight: '900' }}>
          KaliyugAi
        </span>{' '}
        we provide <b>digital astrology personalised consultations</b> and{' '}
        <b>AI-powered insights</b>. Since our offerings are intangible services
        delivered instantly or within a short period, this Cancellation & Refund
        Policy governs all service purchases on our platform.
      </Typography>
      <Typography variant="h3" paragraph>
        <b>Last Updated: </b> [10-September-2025]
      </Typography>
      <Typography variant="h2" sx={{ marginTop: '100px' }}>
        1. Cancellation Policy
      </Typography>
      <Typography variant="homePageBody" paragraph>
        This Cancellation & Refund Policy (“Policy”) applies to all users of{' '}
        <span style={{ fontFamily: 'SpaceGrotesk', fontWeight: '900' }}>
          KaliyugAi
        </span>{' '}
        website who purchase services,Consultations or any digital product
        “Service(s)”. By making a purchase, you agree to be bound by this
        Policy.
        <br />
        This Policy does not apply to third-party services not offered directly
        through{' '}
        <span style={{ fontFamily: 'SpaceGrotesk', fontWeight: '900' }}>
          KaliyugAi
        </span>
        , unless explicitly stated.
      </Typography>
      <Typography variant="homePageBody" paragraph>
        Once a service request consultation raised through Ai Chat box is
        confirmed and processing has begun, <b>cancellation is not possible</b>.
        <br />
        If you believe the Order was placed in error (e.g. duplicate order,
        technical glitch), contact our support immediately{' '}
        <b>(within 2 hours)</b> at
        <Link href="mailto:support@kaliyugai.com" color="secondary">
          <b>support@kaliyugai.com</b>
        </Link>{' '}
        with full details <b>(order ID, user ID, date/time)</b>. We will
        evaluate on a case-by-case basis whether any cancellation can be allowed
        (at our discretion).
      </Typography>
      <Typography variant="h2" sx={{ marginTop: '100px' }}>
        2. Refund Policy
      </Typography>
      <Typography variant="homePageBody" paragraph>
        Because our services are digital and personalized,{' '}
        <b>we follow a strict “No Refund” policy</b> once a service has been
        delivered or initiated. However, refunds may be considered in the
        following exceptional cases:
      </Typography>
      <Typography variant="h3" sx={{ marginTop: '80px' }}>
        2.1. Eligible Refund Scenarios
      </Typography>
      <Typography variant="homePageBody" paragraph>
        <b>Duplicate Payment</b>: If you are charged twice for the same service,
        we will initiate a refund for the duplicate transaction.
        <br />
        <b>Technical Payment Error</b>: If the payment is deducted but the
        service is not confirmed in our system, we will either deliver the
        service or refund the amount.
        <br />
        <b>Service Non-Delivery</b>: If, due to internal error, we fail to
        provide the confirmed service within the committed timeline you may
        request a refund.
      </Typography>
      <Typography variant="h3" sx={{ marginTop: '36px' }}>
        2.2 Non-Refundable Scenarios
      </Typography>
      <Typography variant="homePageBody" paragraph>
        • Dissatisfaction with insights, interpretations, or predictions (as
        astrology is a matter of belief and personal interpretation).
        <br />• Change of mind after booking a consultation or requesting a
        report.
        <br />• Delay caused due to user’s unavailability, incorrect details
        provided, or lack of response from the user.
      </Typography>
      <Typography variant="h2" sx={{ marginTop: '100px' }}>
        3. Refund Timeline
      </Typography>
      <Typography variant="homePageBody" paragraph>
        • Approved refunds will be processed and credited within{' '}
        <b>5–7 business days</b> to the original payment method.
        <br />• Actual credit to your account may take longer depending on your
        bank or payment gateway policies.
      </Typography>
      <Typography variant="h2" sx={{ marginTop: '100px' }}>
        4. How to Request a Refund
      </Typography>
      <Typography variant="homePageBody" paragraph>
        To raise a refund request (for eligible cases only), please contact us
        at{' '}
        <Link href="mailto:support@kaliyugai.com" color="secondary">
          <b>support@kaliyugai.com</b>
        </Link>{' '}
        with
        <br />• Your name and registered email ID
        <br />• Payment transaction ID
        <br />• Date and time of payment
        <br />• Description of the issue
        <br />
        Our team will review and respond within <b>48 hours</b>.
      </Typography>
      <Typography variant="h2" sx={{ marginTop: '100px' }}>
        5. Disputes & Chargebacks
      </Typography>
      <Typography variant="homePageBody" paragraph>
        • If you initiate a chargeback without first contacting{' '}
        <span style={{ fontFamily: 'SpaceGrotesk', fontWeight: '900' }}>
          KaliyugAi
        </span>
        , your account may be suspended until the matter is resolved.
        <br />• We encourage users to reach out to our support team before
        escalating through banks or payment providers.
      </Typography>
      <Typography variant="h2" sx={{ marginTop: '100px' }}>
        6. Policy Updates
      </Typography>
      <Typography
        variant="homePageBody"
        paragraph
        sx={{ marginBottom: '243px' }}
      >
        <b>Kaliyugai AstroTech Pvt Ltd</b> reserves the right to modify this
        policy at any time to reflect business or legal requirements. Updated
        versions will be published on our website with the “Last Updated” date.
      </Typography>
    </Box>
  );
};

export default CancellationRefund;
